import { saveAs } from 'file-saver';
import useArtifactService from './artifactService';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { HTTP } from 'framework/api';
import { useDocumentStorageService } from '../documentStorage';
import { useArtifactRestoreDialog } from './ArtifactRestoreDialog';

const useArtifactDownloadHelper = (
  { isCandidateService, isProjectService, isRiskService, isStaffingService, budgetId } = {} as {
    isCandidateService?: boolean;
    isProjectService?: boolean;
    isRiskService?: boolean;
    isStaffingService?: boolean;
    budgetId?: StringOrNumber;
  },
) => {
  const { addMessage } = useMessageService();
  const showRestoreDialog = useArtifactRestoreDialog();

  const { downloadDocument } = useDocumentStorageService();
  const { downloadArtifact, downloadInvoiceArtifact } = useArtifactService({
    isCandidateService,
    isProjectService,
    isRiskService,
    isStaffingService,
    budgetId,
  });

  const handleDownloadError = async (error: any) => {
    if (error.status !== HTTP.BAD_REQUEST) {
      throw error;
    }

    const body = await error.json();
    const message = body?.message || body?.errors?.message;
    if (message && /archiv|restor/i.test(message)) {
      showRestoreDialog(message);
      return;
    }

    addMessage(new ErrorMessage(message));
  };

  const download = async (id: any, fileName?: string) => {
    try {
      const blob = await downloadArtifact(id);
      saveAs(blob, fileName);
    } catch (error: any) {
      await handleDownloadError(error);
    }
  };

  const downloadDocumentStorage = async (patch: string, fileName?: string) => {
    const blob = await downloadDocument(patch);
    saveAs(blob, fileName || patch?.split('/')?.pop());
  };

  const downloadForInvoice = async (id: any, fileName?: string) => {
    try {
      const blob = await downloadInvoiceArtifact(id);
      saveAs(blob, fileName);
    } catch (error: any) {
      await handleDownloadError(error);
    }
  };

  return {
    download,
    downloadDocumentStorage,
    downloadForInvoice,
  };
};

export default useArtifactDownloadHelper;
